var map = {
	"./emotional-score-cmsc.png": 2977,
	"./emotional-score-math.png": 5341,
	"./emotional-score-stat.png": 2299,
	"./subjective-score-cmsc.png": 1196,
	"./subjective-score-math.png": 1635,
	"./subjective-score-stat.png": 2618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 962;